import styled from 'styled-components'
import InputStep from './InputStep'

export const StyledInputStep = styled(InputStep)`
  position: relative;
  padding-right: ${50}px;
  border-color: ${p => p.theme.colors.$nightRider};
`
StyledInputStep.displayName = 'StyledInputStep'
